import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

// Create a navigation utility that can be used outside of React components
export const createNavigator = () => {
	let navigator = null

	const setNavigator = (navigate) => {
		navigator = navigate
	}

	const navigateToRoute = (path, state = {}) => {
		if (navigator) {
			navigator(path, { state })
		} else {
			console.error('Navigation not initialized. Wrap your app with a NavigationProvider.')
		}
	}

	return {
		setNavigator,
		navigateToRoute,
	}
}

// Create a singleton navigator
export const navigationService = createNavigator()

// A provider component to be used in your main App or routing setup
export const NavigationProvider = ({ children }) => {
	const navigate = useNavigate()

	useEffect(() => {
		navigationService.setNavigator(navigate)
	}, [navigate])

	return children
}
